// export function truncateOrFill(str: string, n: number, side: string = 'right') {
//     let needSpacesQty = n - str.length;
//     let whiteSpace = '';
//     if (needSpacesQty > 0) {
//         for (let i = 0; i < needSpacesQty; i++) {
//             whiteSpace += ' ';
//         }
//     }
//     return str.length > n
//         ? str.substr(0, n - 3) + '...'
//         : side === 'right'
//             ? str + whiteSpace
//             : whiteSpace + str;
// }
// export const formatMoneyString = (
//     amount: string | number = 0,
//     decimalCount: number = 2,
//     decimal = '.',
//     thousands = ',',
//     currencySymbol = '$',
// ) => {
//     try {
//         decimalCount = Math.abs(decimalCount);
//         decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
//         const negativeSign = amount < 0 ? '-' : '';
//         let i = parseInt(
//             (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)),
//         ).toString();
//         let j = i.length > 3 ? i.length % 3 : 0;
//         return (
//             currencySymbol +
//             negativeSign +
//             (j ? i.substr(0, j) + thousands : '') +
//             i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
//             (decimalCount
//                 ? decimal +
//                 Math.abs(amount - i)
//                     .toFixed(decimalCount)
//                     .slice(2)
//                 : '')
//         );
//     } catch (e) {
//         console.log(e);
//     }
// };
// Function to get a formatted address
export function getFormattedAddress(address) {
    const { street, neighborhood, postalCode, city, state, country } = address;
    let formatted = '';
    if (street)
        formatted += street;
    if (neighborhood)
        formatted += `, ${neighborhood}`;
    if (city)
        formatted += `, ${city}`;
    if (state)
        formatted += `, ${state}`;
    if (postalCode)
        formatted += `, ${postalCode}`;
    if (country)
        formatted += `, ${country}`;
    return formatted.trim();
}
